export const THEME = {
  navbarHeight: 60,
  secondaryNavbarHeight: 48,
};
